import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { QuerifyService } from '../services/querify.service';
import { Queries } from './graphql/queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./graphql/queries";
import * as i3 from "../services/querify.service";
var LocationsApi = /** @class */ (function () {
    function LocationsApi(apollo, queries, querify) {
        this.apollo = apollo;
        this.queries = queries;
        this.querify = querify;
    }
    LocationsApi.prototype.search = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.locationsPaginated(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['locations'];
        }));
    };
    LocationsApi.prototype.searchOne = function (locationId) {
        return this.apollo
            .query({
            query: this.queries.searchLocation(),
            variables: { id: locationId }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['location'];
        }));
    };
    LocationsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationsApi_Factory() { return new LocationsApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries), i0.ɵɵinject(i3.QuerifyService)); }, token: LocationsApi, providedIn: "root" });
    return LocationsApi;
}());
export { LocationsApi };
